export const formatDate = (dateObject) => {
    const months = {
        "January": "01",
        "February": "02",
        "March": "03",
        "April": "04",
        "May": "05",
        "June": "06",
        "July": "07",
        "August": "08",
        "September": "09",
        "October": "10",
        "November": "11",
        "December": "12"
    };

    const year = dateObject.year;
    const month = months[dateObject.month];
    const day = String(dateObject.dayOfMonth).padStart(2, '0');

    return `${year}-${month}-${day}`;
};

export const formatDateShort = (date) => {
    const options = { month: 'short', day: 'numeric' };
    return new Date(date).toLocaleDateString(undefined, options);
};

export const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export const getDayOfWeek = (date) => {
    return days[new Date(date).getDay()];
};

//Used for ordering based on size of number
export const formatDateToNumericString = (dateObj) => {
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');  // Ensure 2 digits
    const day = String(dateObj.getDate()).padStart(2, '0');  // Ensure 2 digits
    return `${year}${month}${day}`;
};

export function formatFirestoreTimestamp(firestoreTimestamp) {
    const { seconds, nanoseconds } = firestoreTimestamp;

    // Convert seconds into milliseconds
    const milliseconds = seconds * 1000 + nanoseconds / 1000000;

    // Create a new Date object
    const date = new Date(milliseconds);

    // Format the date to "Month Day, Year"
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString(undefined, options);
}